import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronBoldUp = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m21.243 10.805 14.241 14.242c.687.686.687 1.8 0 2.487l-1.66 1.661a1.759 1.759 0 0 1-2.485.003l-11.34-11.287L8.66 29.197a1.758 1.758 0 0 1-2.484-.003l-1.66-1.66a1.759 1.759 0 0 1 0-2.488l14.241-14.241a1.759 1.759 0 0 1 2.487 0Z" })
});
export default SvgChevronBoldUp;
